import { http } from 'services/http';
import { CARGO_TRIPS_MANY, TRIP_GET_ONE, TRIP_TASKS_GET_MANY } from 'api/query-keys.ts';
import type { TUpdateTripTaskStatusReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

interface IUpdateTripTaskStatusVariables extends TUpdateTripTaskStatusReq {
  tripTaskId: number;
}

export const useUpdateTripTaskStatus = (tripId: number) => {
  return useMutationBase<unknown, unknown, IUpdateTripTaskStatusVariables>({
    mutationFn: async (variables) => {
      const res = await http.patch(`/v1/trips/${tripId}/trip-tasks/${variables.tripTaskId}/status`, {
        status: variables.status,
      });

      return res.data;
    },
    invalidateCallback: () => [
      [TRIP_TASKS_GET_MANY, tripId],
      [CARGO_TRIPS_MANY, tripId],
      [TRIP_GET_ONE, tripId],
    ],
  });
};
